import { render } from 'react-dom';
import { LoadingFallback } from 'components/loading/LoadingFallback';
import('services/hotReload');
import('components/importCss');

import('react').then((React) => {
  import('Root/Root').then(({ default: Root }) => {
    render(
      <React.Suspense fallback={<LoadingFallback />}>
        <Root />
      </React.Suspense>,
      document.getElementById('app-mount')
    );
  });
});
